export const canShowNavReports = receipt => receipt?.is_nav_invoice === true && receipt?.draft === false;
